<button
  mat-raised-button
  class="btn-base"
  [ngClass]="variant"
  [disabled]="disabled"
  (click)="navigate()"
>
  <span class="content">
    <span>{{ text }}</span>

    <mat-icon *ngIf="icon" fontSet="material-icons-outlined">
      {{ icon }}
    </mat-icon>
  </span>
</button>
